import React, { useEffect, useState } from 'react'
import { navbarHeight } from '../App';
import { Link as LinkRouter } from 'react-router-dom'
import { Button, useMediaQuery } from '@material-ui/core';
import ContentSection from './ContentSection';
import MotionGrid from './MotionGrid';
import { FaArrowRight, FaFontAwesome, FaRocket, FaRocketLaunch } from 'react-icons/fa';
import allProjectDicts from '../content/allContent';

const ProjectsSection = () => {

  let getNumRowsAndCols = () => {
    if (screenWidth <= 460) {
      return [3, 2];
    } 
    else if (screenWidth <= 786) {
      return [3, 3];
    }
    else if (screenWidth <= 1024) {
      return [2, 4];
    }
    else if (screenWidth <= 1400) {
      return [2, 4];
    }
    else if (screenWidth <= 1600) {
      return [2, 5];
    }
    return [2, 6];
  };

  const isMobile = useMediaQuery('(max-width: 460px)');
  const isTablet = useMediaQuery('(max-width: 768px)');
  const isLaptop = useMediaQuery('(max-width: 1024px)');
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  const [numRowsAndCols, setNumRowsAndCols] = useState(getNumRowsAndCols());
  const [motionGridCardWidth, setMotionGridCardWidth] = useState(Math.min(parseInt(screenWidth / numRowsAndCols[1]), 400));

  useEffect(() => {
    setScreenWidth(window.innerWidth);
    setNumRowsAndCols(getNumRowsAndCols());
    setMotionGridCardWidth(parseInt(screenWidth / numRowsAndCols[1]));
  }, []);

  return (
    <ContentSection sectionTitle={"Projects"} className='h-250' maxHeight='1200px'>
      {/* border-black border-t-2 border-b-2 */}
      <div className='flex w-screen pt-5 pb-5 bg-light-accent2 dark:bg-dark-accent justify-center'>
        <MotionGrid numCols={numRowsAndCols[1]} numRows={numRowsAndCols[0]} cardWidth={motionGridCardWidth} projectDictsList={allProjectDicts}/>
      </div>
      <div className='shadow-3xl mt-14 rounded-full'>
        <LinkRouter to="/projects" onClick={() => window.scrollTo(0, 0)}  className='flex items-center bg-light-accent border-4 border-dark dark:border-light dark:bg-dark-accent rounded-full p-2 px-5 text-xl text-dark dark:text-light hover:cursor-pointer hover:bg-opacity-70'>
          Go to all projects <FaArrowRight className='ml-3'/>
        </LinkRouter>
      </div>
    </ContentSection>
  )
}

export default ProjectsSection